<header class="fhgrad fixed-top">
  <ng-container *ngIf="!isMobile">

    <div class="bg-white">

      <header class="py-1">
        <div class="container">

          <div class="d-flex align-items-center">
            <div>
              <a  (click)="hideshowmenu()" class="pointer divBtnMenu">
                <i class="bi bi-list cdc1"></i>
              </a>
            </div>
            <div class="px-3">
              <div class="img-fluid fh-logo-div">
                <a href="/"><img class="img-fluid fh-logo-div py-2" src="/assets/images/logofh-cepetdapet.png"></a>
              </div>
            </div>
            <div class="px-0 px-lg-3 flex-grow-1">

              <div class="d-flex" *ngIf="dispaymenu?.isHide">
                <div class="w-100">
                  <input type="text" class="form-control searchinput" placeholder="{{'menu.search' | translate}}" aria-label="Search" aria-describedby="btnGroupAddon" [(ngModel)]="valSearch" (keydown.enter)="globalSearch()" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="flex-shrink-1">
                  <button type="button" class="btn btn-primary  align-self-center bntSearch" (click)="globalSearch()">
                    <font class="d-none d-lg-block">{{'header.search_button' | translate}}</font>
                    <font class="d-block d-lg-none"><img class="fhsearchicon" src="/assets/images/icons/ic_Search@3x.png"></font>
                  </button>
                </div>
              </div>
  
            </div>
            <div class="px-1">
              <div class="">
                <div class="row g-2">
                  <div class="col-6">
                    <a href="/login" class="btn cdbg2 py-2 f2 px-4 w-100 btnNonLoginOut"><strong>{{'menu.login' | translate}}</strong></a>
                  </div>
                  <div class="col-6">
                    <a href="/regis" class="btn py-2 text-white f2 px-4 w-100 btnNonLogin"><strong>{{'menu.regis' | translate}}</strong></a>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="px-2 divIcon">
              <a href="/cart" class="text-white fw-bold pointer">
                <img class="fhIcon" src="/assets/header/cart-fill@3x.png">
              </a>
            </div> -->
            <div class="px-2 divIcon">
              <a href="/messaging" class="text-white fw-bold pointer">
                <img class="fhIcon" src="/assets/header/chat-left-dots-fill@3x.png">
              </a>
            </div>
            <div class="px-2 divIcon">

              <div  class="d-inline-block">
                <a href="/setting/company-management" class="btn dropdown-toggle fhc2 p-0" id="dropdownBasic1" >
                  <img class="fhIcon" src="/assets/header/gear-fill@3x.png">
                </a>
              </div>

            </div>






          </div>

        </div>
      </header>      

    </div>



  <div class="container isHide">
    <div class="row g-0 align-self-center divmenufh m-0">
      <div class="col-sm-4 col-md-4 col-lg-3">
        <a href="/"><img class="img-fluid fh-logo pt-0 pb-0 pe-2" src="/assets/images/logofh-cepetdapet.png"></a>
      </div>
      <div class="col-sm-4 col-md-4 col-lg-6 text-center align-self-center">
        <div class="btn-group w-100 {{invalidSearch?'mt-4':''}}" role="group" aria-label="Button group with nested dropdown">
          <div class="btn-group" role="group">
            <!-- <button id="btnGroupDrop1" type="button" class="btn btn-primary dropdown-toggle fhbtn2 f1" data-bs-toggle="dropdown" aria-expanded="false">
              {{'menu.select_module' | translate}}
            </button> -->
            <!-- <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <li><a class="dropdown-item f1" href="#">Dropdown link</a></li>
              <li><a class="dropdown-item f1" href="#">Dropdown link</a></li>
            </ul> -->
          </div>        
          <input type="text" class="form-control searchinput f1" placeholder="{{'menu.search' | translate}}" aria-label="Search" aria-describedby="btnGroupAddon" [(ngModel)]="valSearch" (keydown.enter)="globalSearch()" [ngModelOptions]="{standalone: true}">
          <button type="button" class="btn btn-primary  align-self-center fhsearchiconbtn" (click)="globalSearch()"><img class="fhsearchicon" src="/assets/images/icons/ic_Search@3x.png"></button>

        </div>
        <small *ngIf="invalidSearch"><font class="text-danger invSearch">Please type keyword minimum 3 character.</font></small>
      </div>
      <div class="col-sm-4 col-md-4 col-lg-3 text-center align-self-center d-md-flex d-sm-flex justify-content-md-center justify-content-sm-center">



        <div class="row w-100 g-0">
          <div class="col-sm-1 col-md-1 col-lg-3 pe-0 ps-0">
            <!-- <a href="" class="btn fhc2 f1  pe-0 ps-0"><strong>{{'menu.discover_more' | translate}}</strong></a> -->
          </div>
          <div class="col-sm-5 col-md-5 col-lg-4">
            <!-- <a href="" class="btn fhc2 f1"><strong>{{'menu.support' | translate}}</strong></a> -->
            <a href="/login" class="btn fhbtn1t text-white f1 ps-2 pe-2 pt-2 pb-2 w-100"><strong>{{'menu.login' | translate}}</strong></a>
          </div>
          <div class="col-1"></div>
          <div class="col-sm-5 col-md-5 col-lg-4">
            <a href="/regis" class="btn fhbtn1 text-white f1 ps-2 pe-2 pt-2 pb-2 w-100"><strong>{{'menu.regis' | translate}}</strong></a>
          </div>
        </div>
        
        
        

      </div>
    </div>

  </div>

  <nav class=" fhbgmenu isHide">
    <div class="container">

      <div class="row g-0">
        <div class="col-3 ">
          <a class="nav-link active fw-bold pointer ps-0" (click)="hideshowmenu()"><img class="fhdashicon"  src="/assets/images/icons/dashicons_menu@3x.png"></a>
        </div>
        <div class="col-9 text-end py-2">
          <div class="">


            
            <!-- <div ngbDropdown class="d-inline-block">
              <button class="btn dropdown-toggle fhc1 ps-0 pe-0 flagbtn" id="dropdownBasic1" ngbDropdownToggle>
                <img class="fhusericon" src="/assets/images/country/{{currentlang}}.png">
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu dropdown-menu-right">
                <div><p class="mb-0 ps-2 pe-2 selectlang">{{'menu.select_language' | translate}} :</p></div>
                <button ngbDropdownItem (click)="switchLang('en')" class="dropdownbg selectlang">English</button>
                <button ngbDropdownItem (click)="switchLang('id')" class="dropdownbg selectlang">Indonesia</button>
              </div>
            </div> -->
            

            <!-- <a href="/procurement/cart" class="text-white fw-bold pointer ps-4"><img class="" src="/assets/images/icons/ic_baseline-notifications-active.png">
              <span class="badge bg-danger fhnotif">7</span>
            </a>
            <a href="/procurement/cart" class="text-white fw-bold pointer ps-4"><img class="" src="/assets/images/icons/fluent_mail-16-filled.png">
              <span class="badge bg-danger fhnotif">7</span>
            </a> -->

            <a href="/cart" class="text-white fw-bold pointer ps-4">
              <img class="fhrighticon" src="/assets/images/icons/clarity_shopping-cart-solid@3x.png">
                <!-- <span class="badge bg-danger fhnotif">7</span> -->
            </a>
            <a href="/messaging" class="text-white fw-bold pointer ps-4">
              <img class="fhrighticon" src="/assets/images/icons/fluent_mail-16-filled@3x.png">
              <!-- <span class="badge bg-danger fhnotif">7</span> -->
            </a>
            <a href="/procurement/cart" class="text-white fw-bold pointer ps-4 d-none">
              <img class="fhrighticon" src="/assets/images/icons/clarity_shopping-cart-solid@3x.png">
              <!-- <span class="badge bg-danger fhnotif">7</span> -->
            </a>

          </div>

        </div>
      </div>

      <!-- <a class="navbar-brand dashicons_menu"><img class="fhusericon" src="/assets/images/icons/dashicons_menu.png"></a>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse container ps-0 pe-0" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item pe-5">
            <a class="nav-link active fw-bold " href="/">Home</a>
          </li>
          <li class="nav-item pe-5">
            <a class="nav-link active fw-bold " href="/vendor/products">Product</a>
          </li>
          <li class="nav-item pe-5">
            <a class="nav-link active fw-bold ">RFQ</a>
          </li>
          <li class="nav-item pe-5">
            <a class="nav-link active fw-bold ">Supliers</a>
          </li>
          <li class="nav-item pe-5">
            <a class="nav-link active fw-bold ">Inbox <span class="badge bg-danger fhnotif">18</span></a>
          </li>
       </ul>
      </div> -->

    </div>
  </nav>
  </ng-container>

  <ng-container *ngIf="isMobile">

    <div class="bg-white">

      <header class="py-0">
        <div class="container">

          <div class="d-flex align-items-center">
            <div>
              <a  (click)="hideshowmenu()" class="pointer m-divBtnMenu">
                <i class="bi bi-list cdc1"></i>
              </a>
            </div>
            <div class="px-3 flex-grow-1">
              <div class="w-100 text-center">
                <div class="img-fluid m-fh-logo-div">
                  <a href="/"><img class="img-fluid fh-logo-div py-2" src="/assets/images/logofh-cepetdapet.png"></a>
                </div>    
              </div>

            </div>
            <div class="px-0 align-content-center">
              <a href="/login">
                <img class="pointer logoCompany" src="/assets/header/building-fiiled.png">
              </a>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="px-0 px-lg-3 flex-grow-1 pb-2">

              <div class="d-flex"  *ngIf="dispaymenu?.isHide">
                <div class="w-100">
                  <input type="text" class="form-control searchinput" placeholder="{{'menu.search' | translate}}" aria-label="Search" aria-describedby="btnGroupAddon" [(ngModel)]="valSearch" (keydown.enter)="globalSearch()" [ngModelOptions]="{standalone: true}">
                </div>
                <div class="flex-shrink-1">
                  <button type="button" class="btn btn-primary  align-self-center bntSearch" (click)="globalSearch()">
                    <font class="d-none d-lg-block">{{'header.search_button' | translate}}</font>
                    <font class="d-block d-lg-none"><img class="fhsearchicon" src="/assets/images/icons/ic_Search@3x.png"></font>
                  </button>
                </div>
              </div>
  
            </div>


          </div>

        </div>
      </header>      

    </div>


    <div class="row g-0 isHide">
      <div class="col-1">
        <a class="nav-link active fw-bold pointer ps-0 pt-3 pe-2" (click)="hideshowmenu()"><img class="fhdashicon"
          src="/assets/images/icons/dashicons_menu@3x.png"></a>
      </div>
      <div class="col-7 ps-0 pe-0">
        <a href="/"><img class="img-fluid pt-2" style="max-width:178.4px;width:100%" src="/assets/images/logofh-cepetdapet.png"></a>
      </div>

      <div class="col-4 px-0 text-center">

        <table class="w-100">
          <tr>
            <td>
              <div class="pt-3 pe-2 text-end">
                <a href="/login">
                  <img class="rounded-circle pointer avatar" src="/assets/images/default-company.jpeg">
                </a>
              </div>
            </td>
            <td>
              <div ngbDropdown class="d-inline-block  pt-3">
                <a href="/login" class="btn dropdown-toggle fhc2 p-0">
                  <img class="fhusericon" src="/assets/images/icons/user@3x.png">
                </a>
              </div>
            </td>
          </tr>
        </table>


      </div>
      <div class="col-12 pb-2">

        <div class="btn-group w-100 {{invalidSearch?'':''}} ps-2 pe-2" role="group" aria-label="Button group with nested dropdown">
          <div class="btn-group" role="group">
            <!-- <button id="btnGroupDrop1" type="button" class="btn btn-primary dropdown-toggle fhsearchdropbtn fhbtn2"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{'menu.select_module' | translate}}
            </button> -->
            <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <li><a class="dropdown-item f1" href="#">Dropdown link</a></li>
              <li><a class="dropdown-item f1" href="#">Dropdown link</a></li>
            </ul>
          </div>
          <input type="text" class="form-control searchinput f1" placeholder="{{'menu.search' | translate}}" aria-label="Search" aria-describedby="btnGroupAddon" [(ngModel)]="valSearch" (keydown.enter)="globalSearch()" [ngModelOptions]="{standalone: true}">
          <button type="button" class="btn btn-primary  align-self-center fhsearchiconbtn" (click)="globalSearch()"><img class="fhsearchicon" src="/assets/images/icons/ic_Search@3x.png"></button>

        </div>
        <small *ngIf="invalidSearch"><font class="text-danger invSearch ps-2">Please type keyword minimum 3 character.</font></small>
      </div>

    </div>
    
  </ng-container>

</header>





<div class="fhsidebar d-flex flex-column flex-shrink-0   {{(sidebar) ? 'fhsidebaractive' : ''}}">
  <div class="w-100">
    <div class="row g-0 slideout {{(sidebar) ? 'slidein' : ''}}">
      <div class="col-sm-12 bg-light hfsidebarcontent" style="max-width: 315px;overflow: auto;">
        <div class="d-flex flex-column flex-shrink-0" style="height: 100vh;">


          <div>
            
            <div class="row align-items-center g-0">
              <div class="col-2"></div>
              <div class="col-8">
                <div class="sidebarLogo text-center">
                  <img class="img-fluid py-2" src="/assets/images/logofh-cepetdapet.png">
                </div>
              </div>
              <div class="col-2">
                <div (click)="hideshowmenu()" class="py-2 text-center">
                  <h5 class="p-0 m-0 pointer bi bi-x-lg cdc1 {{(sidebar) ? '' : 'd-none'}}"></h5>
                </div>
              </div>
            </div>



            

            <div class="col-12 p-2">
              <a href="" class="pointer">
              <div class="divSidebarUser px-2">
                <table class="table mt-2 mb-2 m-0">
                  <tr>
                    <td class="text-center" width="65px">
                      <img class=" logoCompanySidebar" src="/assets/sidebar/building-fiiled@3x.png">
                    </td>
                    <td class="">
                      <a href="/login">
                      <h5 class="p-0 m-0 f2 fw-bold cdc1 mb-1 title"><strong>{{'sidebar.hello' | translate}}, Guest</strong></h5>
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
              </a>
            </div>

            <div class="col-12 p-2 d-block d-sm-none">
              <div class="divNotif">
                <!-- <a href="/cart">
                  <div class="row pb-3">
                    <div class="col-2 text-center">
                      <img class="fhIcon" src="/assets/header/cart-fill@3x.png">
                    </div>
                    <div class="col-7 p-0">{{'sidebar.cart' | translate}}</div>
                    <div class="col-3">
                    </div>
                  </div>
                </a> -->
                <a href="/messaging">
                  <div class="row pb-3">
                    <div class="col-2 text-center">
                      <img class="fhIcon" src="/assets/header/chat-left-dots-fill@3x.png">
                    </div>
                    <div class="col-6 p-0">{{'sidebar.message' | translate}}</div>
                    <div class="col-4">
                    </div>
                  </div>
                </a>

                <a href="/setting/company-management">
                  <div class="row pb-1">
                    <div class="col-2 text-center">
                      <img class="fhIcon" src="/assets/header/gear-fill@3x.png">
                    </div>
                    <div class="col-8 p-0">{{'sidebar.setting' | translate}}</div>
                    <div class="col-2 text-end">
                    </div>
                  </div>
                </a>
                
              </div>
            </div>




            <div class="col-12 p-2 divMenuSidebar">

              <div class="px-3">
                <div class="menuTitle py-2">
                  {{'menu.dashboard' | translate}}
                </div>
              </div>

              <hr>

              <div class="px-3">
                <div class="menuTitle py-2">
                  {{'menu.product' | translate}}
                </div>
                <!-- <div class="py-2">
                  <a class="menuLink" href="/vendor/product-catalogue">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-book@3x.png" > {{'menu.product_catalogue' | translate}}
                  </a>
                </div> -->

                <div class="py-2">
                  <a class="menuLink" href="/vendor/product-list">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-bag@3x.png" > {{'menu.my_product' | translate}}
                  </a>
                </div>

                <div class="py-2">
                  <a class="menuLink" href="/vendor/product/add">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-bag-plus@3x.png" > {{'menu.add_product' | translate}}
                  </a>
                </div>

              </div>

              <hr>

              <div class="px-3">
                <div class="menuTitle py-2">
                  {{'menu.vendor_feature' | translate}}
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/vendor/rfq-board">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-card-list@3x.png" > {{'menu.rfq_market' | translate}}
                  </a>
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/vendor/rfq-participating-in-list">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-file-earmark-text@3x.png" > {{'menu.rfq_participate' | translate}}
                  </a>
                </div>
              </div>  
              
              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/vendor/rfq-participating-in/history">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-clock-history@3x.png" > {{'menu.history_participate' | translate}}
                  </a>
                </div>
              </div>  

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/vendor/rating/rating-list">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-list-stars@3x.png" > {{'menu.review_rfq' | translate}}
                  </a>
                </div>
              </div>  


              <hr>
              
              <div class="px-3">
                <div class="menuTitle py-2">
                  {{'menu.procurement_feature' | translate}}
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/procurement/rfq-list">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-card-list@3x.png" > {{'menu.my_rfq' | translate}}
                  </a>
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/procurement/rfq/my-proforma-po">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-card-checklist@3x.png" > {{'menu.list_proforma_po' | translate}}
                  </a>
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/procurement/rfq/recurring">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-arrow-repeat@3x.png" > {{'menu.recurring_rfq' | translate}}
                  </a>
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/procurement/rfq-history">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-clock-history@3x.png" > {{'menu.history_rfq' | translate}}
                  </a>
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/procurement/rating/procurement-rating-list">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-list-stars@3x.png" > {{'menu.review_quotation' | translate}}
                  </a>
                </div>
              </div>  



              <hr>
              
              <div class="px-3">
                <div class="menuTitle py-2">
                  {{'menu.company_setting' | translate}}
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/setting/company-detail">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-building@3x.png" > {{'menu.company_detail' | translate}}
                  </a>
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/setting/staff-management">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-people@3x.png" > {{'menu.manage_staff' | translate}}
                  </a>
                </div>
              </div>

              <div class="px-3">
                <div class="py-2">
                  <a class="menuLink" href="/setting/company-management">
                    <img style="max-width:20px;" class="me-2" src="/assets/sidebar/icon-wrench@3x.png" > {{'menu.setting' | translate}}
                  </a>
                </div>
              </div>
              

              <!-- 
              "manage_staff":"Manajemen Staf",
              "package_cepetdapet":"Paket CepetDapet",
              "marketing":"Marketing",
              "setting":"Preferensi" -->


              <hr>
              
              <div class="py-2">
              </div>


            </div>

          </div>


          <div class="bgsidebarhead  pt-4 pb-4 isHide">
            <table class="table mt-2 mb-2 m-0">
              <tr>
                <td class="text-end"><a href="/login"><h2 class="mt-0 mb-0 pt-0 pb-0 bi bi-person-circle text-white"></h2></a></td>
                <td class="text-white">
                  <h5 class="p-0 m-0 f1"><strong><a href="/login" class="text-white ps-2">Hello, Guest </a></strong></h5>
                  <!-- <h6 class="p-0 m-0 f1l subtitle">:</h6>  -->
                </td>
              </tr>
            </table>
          </div>
          <ul class="nav flex-column mb-auto isHide">
            <!-- <li class="nav-item menusidediv pointer" *ngFor="let menu of sidebarmenu; let i = index">
              <a *ngIf="(menu.parent)" href="{{menu.url}}" class="nav-link f1 mt-2 mb-2">
                <img class="sideicon {{ (menu.parent)? 'ps-5':'' }}" src="{{menu.icon}}"> {{menu.text}}
              </a>
            </li> -->
            <ng-container *ngFor="let menu of sidebarmenu; let i = index">
              <li class="nav-item menusidediv pointer {{ arrowmenu(menu.id,menu.parent) }}">
              <a href="{{menu.url}}" class="nav-link f1 mt-2 mb-2" *ngIf="(menu.parent); else Parent">
                <img class="sideicon ps-5" src="{{menu.icon}}"> {{menu.text}}
              </a>
              <ng-template #Parent>
                <a *ngIf="menu.url!==''" href="{{menu.url}}" class="nav-link f1 mt-2 mb-2">
                  <img class="sideicon" src="{{menu.icon}}"> {{menu.text}}
                </a>
                <a *ngIf="menu.url==''" class="nav-link f1 mt-2 mb-2" (click)="hideshowChild(menu.id)">
                  <div class="row">
                    <div class="col-10">
                      <img class="sideicon" src="{{menu.icon}}"> {{menu.text}}
                    </div>
                    <div class="col-2  text-end">
                      <b><i class="bi {{(dispaymenu[menu.id])?'bi-chevron-up':'bi-chevron-down'}}  arrowmenu"></i></b> 
                    </div>
                  </div>
                  
                </a>
              </ng-template>
              </li>
            </ng-container>

            
          </ul>
          <div class="dropdown isHide">
            <ul class="nav flex-column mb-auto">
              <li class="nav-item menusidediv menusidefooter">
                <a href="/login" class="nav-link f1 pointer mt-2 mb-2">
                  <img class="sideicon" src="/assets/images/icons/ic_round-log-out.png"> Log In
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="col pt-3 ps-3" (click)="hideshowmenu()">
        <i class="pointer bi bi-x-lg text-white {{(sidebar) ? '' : 'd-none'}}"></i>
      </div> -->
    </div>
  </div>
</div>



<a id="totop" class="ps-1 pe-1 membertotop bg1 {{showtotop?'show':''}}" (click)="gototop()"><h3 class="bi bi-arrow-up-short mb-0"></h3></a>



